module.exports = __webpack_public_path__ + "img/success-academy-achievements.5851b8fe.png";